import { setHeader, axiosGet, axiosPost, axiosDelete } from "../options/header"
import { store } from '@/vuex/store'
import axios from 'axios'

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getMembers(token, idGrupe) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },
  getOwners(token, idGrupe) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },
  getSelf() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current",
        {
          params: {
            
          },
          
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getSelfAnalytics(accessToken) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current/start-analytics",
        {
          params: {
            
          },
          
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getSearchEvents(uid, srch_txt) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current/events-search",
        {
          params: {
            uid,
            srch_txt
          },
          
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  openedNotifications(uid) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current/notification-open",
        {
          params: {
            uid
          },
          
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getFilteredUsers(accessToken, tekst) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/users",
        {
          params: {
            
            tekst: String(tekst)
          },
          
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getUserPhoto(uid) {
    try {
      return axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current/avatar",
        data : {
          uid : uid
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      })

    }
    catch{
      console.log("Failed attempt at person.");
    }

  },
  addNewAvatar(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/auth/user/current/avatar/new", formData)
    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  addNewMember(token, idGrupe, korisnik) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
            korisnik: korisnik
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },
  removeMember(token, idGrupe, korisnik) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
            korisnik: korisnik
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },
  removeOwner(token, idGrupe, korisnik) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
            korisnik: korisnik
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },
  addNewOwner(token, idGrupe, korisnik) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
            korisnik: korisnik
          },
          
        });
    } catch (err) {
      console.log(err);
    }
  },


}

